<template>
  <div class="producer-products">
    <bp-table-header
      class="mb-6"
      :total="pagination.count"
      @refresh="refresh"
      @open-filter="filter = true"
    >
      <template #input>
        <bp-input
          v-model="params.search"
          size="md"
          placeholder="Buscar..."
          :delay="600"
          @change="refresh"
        />
      </template>

      <template #filter>
        <responsive-modal
          v-model="filter"
          title="Filtrar"
          description="Selecione os filtros e aplique"
        >
          <product-filter
            :params="params"
            @submit="applyFilters"
            @close="filter = false"
          />
        </responsive-modal>
      </template>

      <template #buttons>
        <bp-button
          size="md"
          icon="fa fa-plus"
          label="Novo produto"
          @click="$router.push({ name: 'product-new' })"
        />
      </template>
    </bp-table-header>

    <div v-if="loading" class="centering pt-6">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" />
    </div>

    <template v-else-if="products.length">
      <div class="product-cards">
        <product-card
          v-for="product in products"
          :key="product.id"
          :product="product"
          @refresh="refresh"
        />
      </div>

      <div class="d-flex justify-content-end">
        <bp-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </template>

    <div v-else class="text-center">
      <img
        class="d-block my-9 mx-auto"
        src="@/assets/images/home/welcome.svg"
      />
      <h5>Não foram encontrados produtos</h5>
    </div>
  </div>
</template>
<script>
import ProductFilter from "./Filter";
import ProductCard from "./ProductCard";

import { clearObject } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: { ProductCard, ProductFilter },
  data() {
    return {
      loading: false,
      filter: false,
      page: 1,
      params: {
        search: "",
        status: "",
        type_product: "",
        created_at_after: "",
        created_at_before: ""
      }
    };
  },
  computed: {
    ...mapState("product", ["products", "pagination"]),
    ...mapState("user", ["preferences"]),
    gallery() {
      return this.preferences.product_list === "gallery";
    }
  },
  methods: {
    applyFilters(data) {
      this.params = { ...this.params, ...data };
      this.refresh();
    },
    refresh() {
      this.page = 1;
      this.dispatch();
    },
    dispatch(offset) {
      this.loading = true;

      this.$store
        .dispatch("product/get", clearObject({ ...this.params, offset }))
        .catch(() => {
          this.$message.error("Erro ao recuperar produtos");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.dispatch();
  }
};
</script>

<style lang="scss" scoped>
.product-cards {
  gap: 12px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  transition: grid-template-columns 0.3s;
}
</style>
